<template>
    <div v-wechat-title="title">
        <div style="margin: 5px">
            <div>
                <el-input style="margin-top: 30px" type="textarea" :rows="2" placeholder="请输入模板名称" v-model="textarea" @blur="check"></el-input>
            </div>
        </div>
        <CloseButton type="confirm" ref="close-btn" @confirm="surgeryReturn" :data="data" :msg="msg"> </CloseButton>
    </div>
</template>
<script>
export default {
    name: `RecordOtherRemplatesSaveAs`,
    props: {

    },
    data() {
        return {
            title: `另存单据内容模板`,
            token: this.$route.query.token,
            id: this.$route.query.surgery_id,
            recordType: this.$route.query.record_type,
            allowTemplateRow: this.$route.query.allowTemplateRow,
            AfterOtherEventClickProc: this.$root.AfterOtherEventClickProc,
            data: {},
            msg: `closeWindow`,
            textarea: ``
        }
    },
    created() {
        sessionStorage.setItem(`token`, this.token)
    },
    computed: {
    },
    methods: {
        surgeryReturn() {
            let that = this
            if (!that.check()) return false
            return new Promise((resolve) => {
                let req = that.myaxios.put(`/api/AcisSystem/AnesthsiaOtherTemplate/SaveAsOtherRemplate`, {
                    id: this.$route.query.surgery_id,
                    recordType: this.recordType,
                    remplatename: this.textarea,
                    allowTemplateRow: this.allowTemplateRow
                })
                req.then(data => {
                    that.data = { surgeryId: this.$route.query.surgery_id }
                    that.msg = `ok`
                    that.sendMessage()
                    that.$refs[`close-btn`].close()
                }).catch(e => { console.log(e) })
            })
        },
        check() {
            if (this.textarea === ``) {
                this.$message.warning(`模板名称不能为空`)
                return false
            }
            return true
        },
        sendMessage() {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    data: this.data,
                    action: this.msg
                }
                winformMsg.acceptMessage(cefJson)
            }
        }
    },
    watch: {
    }
}
</script>
<style scoped>
.note {
    display: inline-block;
    position: absolute;
    left: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Anesthsia/RecordOtherRemplatesSaveAs.vue